@if (isSignerOrderInfo) {
  <div class="header">
    <strong>Signer's order information</strong>
  </div>
}
@if (!isSignerOrderInfo) {
  <div class="header">
    <strong>ID analysis information</strong>
  </div>
}
<div class="card-body" data-private>
  <div>
    {{ addressInformation.firstName }} {{ addressInformation.lastName }}
  </div>
  <div>
    {{ streetAddress }}
  </div>
  <div>
    {{ addressInformation.city }}, {{addressInformation.stateCode }} {{ addressInformation.zipCode }}
  </div>
</div>
